<template>
  <v-container class="pd16">
    <strong class="t-cont-title">계약정보</strong>
    <table class="t-table table1">
      <colgroup>
        <col width="65px" />
        <col width="*" />
      </colgroup>
      <tr>
        <th>계약자명</th>
        <td>{{ contractInfo.contractorName }}</td>
      </tr>
      <tr v-if="hasContractorAddress">
        <th>주소지</th>
        <td>{{ contractor.address1 }} {{ contractor.address2 }}</td>
      </tr>
      <tr v-if="hasContractorMobile">
        <th>휴대폰번호</th>
        <td>{{ contractor.mobile | hyphen }}</td>
      </tr>
      <tr>
        <th>계약일자</th>
        <td>
          {{ contractInfo.contractDate }}
        </td>
      </tr>
      <tr>
        <th>재산의 표시</th>
        <td>
          {{ contractInfo.assetAddress }}
        </td>
      </tr>
      <tr>
        <th>주택의 유형</th>
        <td>
          {{
            contractInfo.assetCategory == ""
              ? "아파트"
              : contractInfo.assetCategory
          }}
        </td>
      </tr>
      <tr>
        <th>면적타입(㎡)</th>
        <td>{{ contractInfo.areaType }}</td>
      </tr>
      <tr>
        <th>입주 예정일</th>
        <td>
          {{ getMoveinText() }}
        </td>
      </tr>
      <tr>
        <th colspan="2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15.005"
            height="15.005"
            viewBox="0 0 15.005 15.005"
          >
            <g
              id="Icon_ionic-md-information-circle-outline"
              data-name="Icon ionic-md-information-circle-outline"
              transform="translate(-3.375 -3.375)"
            >
              <path
                id="패스_501"
                data-name="패스 501"
                d="M10.877,4.89A5.985,5.985,0,1,1,6.643,6.643,5.963,5.963,0,0,1,10.877,4.89m0-1.515a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z"
                transform="translate(0 0)"
                fill="#F9A36C"
              />
              <path
                id="패스_502"
                data-name="패스 502"
                d="M18.038,18.19H16.523V13.681h1.515Zm0-5.988H16.523V10.687h1.515Z"
                transform="translate(-6.403 -3.561)"
                fill="#F9A36C"
              />
            </g>
          </svg>
          공정에 따라 변경될 수 있으며, 이 경우 추후 개별 통보합니다.
        </th>
      </tr>
    </table>

    <div v-if="showContractorActionButtons" class="contract-action-section">
      <div class="contract-action-buttons">
        <v-btn color="primary" class="fts14 ftw7 mw-140 pwidth100" min-height="40"
          @click="openContractChangeWithVerification"
        >
          계약자 정보 변경
        </v-btn>
        <v-btn color="primary" class="fts14 ftw7 mw-140 pwidth100" min-height="40"
          @click="openHistoryDialog"
        >
          정보 변경 이력
        </v-btn>
      </div>
    </div>

    <strong class="t-cont-title">
      계약면적
      <span>[면적단위:㎡]</span>
      <p>{{ contractInfo.totalArea }}</p>
    </strong>
    <table class="t-table table2">
      <colgroup>
        <col width="112px" />
        <col width="*" />
      </colgroup>
      <tr>
        <th>공급면적<br />{{ contractArea }}</th>
        <td>
          <div
            class="line-box"
            v-for="supplyArea in contractInfo.supplyArea"
            :key="supplyArea.name"
          >
            <div class="left">{{ supplyArea.name }}</div>
            <div class="right">{{ supplyArea.area }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <th>기타공용면적<br /></th>
        <td>
          <div
            class="line-box"
            v-for="sharedArea in contractInfo.sharedArea"
            :key="sharedArea.name"
          >
            <div class="left" v-if="sharedArea.area != 0">
              {{ sharedArea.name }}
            </div>
            <div class="right" v-if="sharedArea.area != 0">
              {{ sharedArea.area }}
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>대지면적<br /></th>
        <td>
          <div class="line-box">
            <div class="right">
              {{ contractInfo.landArea }}
            </div>
          </div>
        </td>
      </tr>
      <!-- <tr>
        <th>면적 합계</th>
        <td>
          <div class="line-box">
            <div class="right">
              {{ contractInfo.totalArea }}
            </div>
          </div>
        </td>
      </tr> -->
    </table>

    <strong class="t-cont-title">
      공급대금 및 납부일정
      <span>[금액단위:원]</span>
    </strong>
    <table class="t-table table3 mb15">
      <colgroup>
        <col width="33%" />
        <col width="33%" />
        <col width="34%" />
      </colgroup>
      <tr class="total">
        <th colspan="3">계약금</th>
      </tr>
      <tr
        v-for="payment in contractInfo.sellInfo.depositDownPayment"
        v-bind:key="'D' + payment.count"
      >
        <th>
          {{
            payment.count == 0
              ? ""
              : (payment.count > 10 ? payment.count - 10 : payment.count) +
                "회차"
          }}
        </th>
        <td>{{ payment.paymentDate }}</td>
        <td>{{ payment.balance | comma }}</td>
      </tr>
      <tr>
        <th class="ftw5">소계</th>
        <td></td>
        <td>
          {{
            getTotalBalance(contractInfo.sellInfo.depositDownPayment) | comma
          }}
        </td>
      </tr>
      <tr class="total">
        <th colspan="3">중도금</th>
      </tr>
      <tr
        v-for="payment in contractInfo.sellInfo.depositSecondPayment"
        v-bind:key="'S' + payment.count"
      >
        <th>{{ payment.count == 0 ? "" : payment.count + "회차" }}</th>
        <td>{{ payment.paymentDate }}</td>
        <td>{{ payment.balance | comma }}</td>
      </tr>
      <tr>
        <th class="ftw5">소계</th>
        <td></td>
        <td>
          {{
            getTotalBalance(contractInfo.sellInfo.depositSecondPayment) | comma
          }}
        </td>
      </tr>
      <!-- <tr class="total">
        <th>잔금</th>
        <td>입주지정기간</td>
        <td v-if="contractInfo.sellInfo.depositBalance">
          {{ contractInfo.sellInfo.depositBalance.balance | comma }}
        </td>
      </tr> -->
      <tr class="total">
        <th colspan="3">잔금</th>
      </tr>
      <tr
        v-for="(payment, idx) in contractInfo.sellInfo.depositBalance"
        v-bind:key="'B' + idx"
      >
        <th>{{ payment.count == 0 ? "" : payment.count + "회차" }}</th>
        <td style="white-space: nowrap;">
          <span
            v-if="
              payment.paymentStartDate &&
                payment.paymentDate != payment.paymentStartDate
            "
            >{{ payment.paymentStartDate }} ~
          </span>
          {{ payment.paymentDate }}
        </td>
        <td>{{ payment.balance | comma }}</td>
      </tr>
      <tr>
        <th class="ftw5">소계</th>
        <td></td>
        <td>
          {{ getTotalBalance(contractInfo.sellInfo.depositBalance) | comma }}
        </td>
      </tr>
    </table>

    <table class="t-table table4">
      <colgroup>
        <col width="33%" />
        <col width="*" />
      </colgroup>
      <tr class="total">
        <th>합계</th>
        <td>
          {{
            (contractInfo.sellInfo.landPrice +
              contractInfo.sellInfo.constructPrice +
              contractInfo.sellInfo.vat)
              | comma
          }}
        </td>
      </tr>
      <tr>
        <th>대지비</th>
        <td>{{ contractInfo.sellInfo.landPrice | comma }}</td>
      </tr>
      <tr>
        <th>건축비</th>
        <td>{{ contractInfo.sellInfo.constructPrice | comma }}</td>
      </tr>
      <tr>
        <th>부가세</th>
        <td>{{ contractInfo.sellInfo.vat | comma }}</td>
      </tr>
    </table>

    <strong class="t-cont-title">납부처 및 납부방법</strong>
    <table class="t-table table5">
      <colgroup>
        <col width="80px" />
        <col width="*" />
      </colgroup>
      <tr>
        <th>납부기관</th>
        <td>{{ contractInfo.bankName }}</td>
      </tr>
      <tr>
        <th>납부계좌</th>
        <td>{{ contractInfo.bankAccount }}</td>
      </tr>
      <tr>
        <th>예금주</th>
        <td>{{ contractInfo.accountHolder }}</td>
      </tr>
      <tr>
        <th>납부방법</th>
        <td>무통장 입금</td>
      </tr>
    </table>

    <div class="order-list">
      <!-- <p>
        ※상기 계좌는 고객별 가상계좌번호로서 입금시 분양대금 납부계좌로 이체되어
        관리됩니다.
      </p> -->
      <p>
        ※견본주택 및 분양사무실에서는 일체의 현금을 취급하지 않으며, 각 회차별
        약정금액 중 상기 납부계좌에 입금되지 않은 금액에 대해서는 어떠한
        경우라도 당사에서 일체 책임지지 않습니다.
      </p>
      <p>
        ※분양대금 납부시에는 상기 납부계좌에 계약자 본인명의 및 동·호수로
        무통장입금하여 주시기바랍니다.(계약자 본인 이외의 명의로 분양대금
        입금시, 이를 증명할 수 있는 일체의 서류를 계약자 본인이 준비하여
        제출하여야 함)
      </p>
    </div>

    <v-dialog
      :value="contractChangeDialog"
      max-width="500"
      persistent
      @input="handleContractorDialogInput('change', $event)"
    >
      <div class="contract-change-popup">
        <strong class="contract-change-popup__title">계약 정보 변경</strong>

        <div class="contract-change-popup__actions">
          <button
            type="button"
            class="popup-action-button is-orange"
            @click="openBasicInfoDialog"
          >
            기본정보 변경
            <span style="font-size: 11px;">(연락처/이메일/우편물 수령주소)</span>
          </button>
          <button
            type="button"
            class="popup-action-button is-dark"
            :disabled="isIdentityChangeButtonDisabled"
            @click="openIdentityInfoDialog"
          >
            계약자 개인정보 변경 요청
            <span>(성명/주민등록번호)</span>
          </button>
        </div>

        <p
          v-if="showIdentityChangeRestrictionNotice"
          class="contract-change-popup__helper"
        >
          {{ identityChangeRestrictionNoticeText }}
        </p>

        <div class="contract-change-popup__notes">
          <p>※ 기본정보 변경은 연락처/이메일/우편물 수령주소 등이 바로 변경되는 서비스 입니다.</p>
          <p>
            ※ 계약자 개인정보 변경 요청은 본인의 주요 계약 정보를 변경하는 서비스로
            이름/주민번호를 변경 할 수 있으며 해당 변경 사유를 작성하신 뒤 변경된
            정보를 위해 주민등록초본/등본 등을 요구 할 수 있습니다.
          </p>
          <p>※ 계약자 개인정보 변경 요청의 경우 우미 린 에서 승인 후 정보가 변경 됩니다.</p>
        </div>

        <div class="contract-change-popup__footer">
          <button
            type="button"
            class="contract-change-popup__close"
            @click="closeContractorDialog"
          >
            닫기
          </button>
        </div>
      </div>
    </v-dialog>

    <ContractorBasicInfoChangeDialog
      v-if="hasContractorInfo"
      :value="basicInfoDialog"
      :contractor-info="contractor"
      :user="user"
      :loading="basicInfoSubmitting"
      @input="handleContractorDialogInput('basic', $event)"
      @back="handleBasicInfoBack"
      @submit="handleBasicInfoSubmit"
      @sendEmailCode="handleBasicInfoSendEmailCode"
    />

    <ContractorIdentityInfoChangeDialog
      v-if="hasContractorInfo"
      :value="identityInfoDialog"
      :contract-id="home.id"
      :user="user"
      :contractor="contractor"
      :active-change-request="activeIdentityChangeRequest"
      :loading="identityInfoSubmitting"
      @input="handleContractorDialogInput('identity', $event)"
      @back="handleIdentityInfoBack"
      @submit="handleIdentityInfoSubmit"
    />

    <ContractorInfoChangeHistoryDialog
      v-if="hasContractorInfo"
      :value="historyDialog"
      :contract-id="home.id"
      :is-corporate="isCorporateContractor"
      @input="handleContractorDialogInput('history', $event)"
    />

    <ContractorInfoVerificationDialog
      v-if="hasContractorInfo"
      :value="verificationConfirmDialog"
      @input="handleContractorDialogInput('verification', $event)"
      @confirm="startContractorInfoVerification"
    />

    <v-dialog v-model="isVerificationLoading" persistent max-width="360">
      <div class="verification-transition-popup">
        <strong class="verification-transition-popup__title">실명인증 확인 중</strong>
        <v-progress-linear
          indeterminate
          rounded
          color="#e66a1f"
          height="6"
          class="verification-transition-popup__progress"
        />
        <p class="verification-transition-popup__text">
          실명인증이 완료되었습니다. 잠시만 기다려주세요.
        </p>
      </div>
    </v-dialog>

  </v-container>
</template>

<script>
import {
  changeContractorBasicInfo,
  changeContractorBasicInfoSendEmailCode,
  changeContractorIdentityInfo,
  getContract,
  // getContractor,
  getContractorDetails,
  getContractorIdentityChangeRequest
} from "@/api/contract.js";
import { getUserData } from "@/api/index.js";
import ContractorBasicInfoChangeDialog from "@/components/Contract/ContractorBasicInfoChangeDialog";
import ContractorIdentityInfoChangeDialog from "@/components/Contract/ContractorIdentityInfoChangeDialog";
import ContractorInfoChangeHistoryDialog from "@/components/Contract/ContractorInfoChangeHistoryDialog";
import ContractorInfoVerificationDialog from "@/components/Contract/ContractorInfoVerificationDialog";

const CONTRACTOR_DIALOG_QUERY_KEY = "contractorDialog";

export default {
  components: {
    ContractorBasicInfoChangeDialog,
    ContractorInfoChangeHistoryDialog,
    ContractorIdentityInfoChangeDialog,
    ContractorInfoVerificationDialog,
  },
  name: "StatusForSell",
  data() {
    return {
      contractArea: 0, //계약면적
      contractInfo: {
        contractNo: "",
        contractType: "",
        contractorName: "",
        contractorIdentityNumber: "",
        contractDate: "",
        contractorAddress: "",
        contractorMobile: "",
        moveInDate: "",
        assetAddress: "",
        assetCategory: "",
        assetType: "",
        assetAreaType: "",
        contractArea: 0,
        dedicatedArea: 0,
        residentialSharedArea: 0,
        ohterSharedArea: 0,
        contractOption: "",
        bankName: "",
        bankAccount: "",
        accountHolder: "",
        corpRegNumber: "",
        customerSupportTelephone: "",
        sellInfo: {},
        leaseInfo: null,
      },
      activeIdentityChangeRequest: null,
      activeIdentityChangeRequestFetchFailed: false,
      contractor: {},
      contractorInfoLoaded: false,
      contractChangeDialog: false,
      basicInfoDialog: false,
      identityInfoDialog: false,
      historyDialog: false,
      verificationConfirmDialog: false,
      // 실명인증 복귀 후 계약 정보 변경 팝업을 열기 전까지 전체 로딩을 관리한다.
      isVerificationLoading: false,
      // 인증 복귀 중 뒤로가기 방어 상태를 관리한다.
      verificationBackGuardActive: false,
      verificationBackNoticeLocked: false,
      basicInfoSubmitting: false,
      identityInfoSubmitting: false,
    };
  },
  computed: {
    home() {
      return this.$store.getters.getHome;
    },
    user() {
      return this.$store.getters.getUser || {};
    },
    hasContractorInfo() {
      return Object.keys(this.contractor || {}).length > 0;
    },
    hasContractorAddress() {
      return !!(this.contractor.address1 || this.contractor.address2);
    },
    hasContractorMobile() {
      return !!this.contractor.mobile;
    },
    showContractorActionButtons() {
       return this.hasContractorInfo;
    },
    isCorporateContractor() {
      return !!this.contractor.is_corporate;
    },
    showIdentityChangeRestrictionNotice() {
      return (
        this.showContractorActionButtons &&
        (this.activeIdentityChangeRequestFetchFailed || this.isCorporateContractor)
      );
    },
    isIdentityChangeButtonDisabled() {
      return (
        this.isIdentityChangePending ||
        this.activeIdentityChangeRequestFetchFailed ||
        this.isCorporateContractor
      );
    },
    identityChangeRestrictionNoticeText() {
      if (this.isCorporateContractor) {
        return "법인 계약 담당자는 기본정보 변경만 가능합니다.";
      }

      return "현재 진행 중인 계약자 개인정보 변경 요청 상태를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    },
    isIdentityChangePending() {
      return this.isApprovalLockedIdentityChangeStatus(
        this.activeIdentityChangeRequest?.status
      );
    },
    hasEditableIdentityChangeRequest() {
      return !!(
        this.activeIdentityChangeRequest &&
        this.hasIdentityChangedField(this.activeIdentityChangeRequest) &&
        this.isEditableIdentityChangeStatus(this.activeIdentityChangeRequest.status)
      );
    },
  },
  watch: {
    "$route.query": {
      handler() {
        this.syncContractorDialogsFromRoute();
        this.enforceContractorDialogAvailabilityFromRoute();
        this.showVerificationLoadingIfNeeded();
        this.handleVerificationResult();
      },
      immediate: true,
    },
  },
  methods: {
    getContractorDialogFromRoute() {
      return String(this.$route.query[CONTRACTOR_DIALOG_QUERY_KEY] || "");
    },
    getContractorDialogQuery(dialog) {
      const query = { ...this.$route.query };

      if (dialog) {
        query[CONTRACTOR_DIALOG_QUERY_KEY] = dialog;
      } else {
        delete query[CONTRACTOR_DIALOG_QUERY_KEY];
      }

      return query;
    },
    ignoreDuplicatedNavigation(error) {
      if (error && error.name !== "NavigationDuplicated") {
        throw error;
      }
    },
    openContractorDialog(dialog) {
      if (this.getContractorDialogFromRoute() === dialog) {
        return Promise.resolve();
      }

      return this.$router
        .push({ query: this.getContractorDialogQuery(dialog) })
        .catch(this.ignoreDuplicatedNavigation);
    },
    replaceContractorDialog(dialog) {
      if (this.getContractorDialogFromRoute() === dialog) {
        return Promise.resolve();
      }

      return this.$router
        .replace({ query: this.getContractorDialogQuery(dialog) })
        .catch(this.ignoreDuplicatedNavigation);
    },
    syncContractorDialogsFromRoute() {
      const dialog = this.getContractorDialogFromRoute();

      this.verificationConfirmDialog = dialog === "verification";
      this.contractChangeDialog = dialog === "change";
      this.basicInfoDialog = dialog === "basic";
      this.identityInfoDialog = dialog === "identity";
      this.historyDialog = dialog === "history";
    },
    enforceContractorDialogAvailabilityFromRoute() {
      if (!this.contractorInfoLoaded) {
        return;
      }

      const dialog = this.getContractorDialogFromRoute();

      if (!dialog) {
        return;
      }

      if (
        ["change", "basic", "identity", "history"].includes(dialog) &&
        !this.showContractorActionButtons
      ) {
        this.clearContractorDialogRoute();
        return;
      }

      if (dialog === "identity" && this.isIdentityChangeButtonDisabled) {
        this.replaceContractorDialog("change");
      }
    },
    handleContractorDialogInput(dialog, isOpen) {
      if (isOpen) {
        this.openContractorDialog(dialog);
        return;
      }

      if (this.getContractorDialogFromRoute() === dialog) {
        this.closeContractorDialog();
      }
    },
    resetContractorDialogs() {
      this.verificationConfirmDialog = false;
      this.contractChangeDialog = false;
      this.basicInfoDialog = false;
      this.identityInfoDialog = false;
      this.historyDialog = false;
    },
    closeContractorDialog() {
      if (this.getContractorDialogFromRoute()) {
        // 페이지 이동 대신 모든 팝업을 닫고 쿼리 초기화.
        this.$router.back();
        return;
      }

      this.resetContractorDialogs();
    },
    backToContractChangeDialog() {
      if (["basic", "identity"].includes(this.getContractorDialogFromRoute())) {
        this.$router.back();
        return;
      }

      this.openContractorDialog("change");
    },
    clearContractorDialogRoute() {
      return this.replaceContractorDialog("");
    },
    fetchActiveIdentityChangeRequest() {
      if (!this.home.id) {
        this.activeIdentityChangeRequest = null;
        this.activeIdentityChangeRequestFetchFailed = false;
        return Promise.resolve(true);
      }

      this.activeIdentityChangeRequestFetchFailed = false;
      return getContractorIdentityChangeRequest(this.home.id)
        .then((response) => {
          this.activeIdentityChangeRequest = this.extractActiveIdentityChangeRequest(response.data);
          this.activeIdentityChangeRequestFetchFailed = false;
          return true;
        })
        .catch((error) => {
          this.activeIdentityChangeRequest = null;
          this.activeIdentityChangeRequestFetchFailed = true;
          console.error("Error fetching active contractor identity change request:", error);
          this.$store.commit(
            "ERROR",
            "현재 진행 중인 계약자 개인정보 변경 요청 상태를 불러오지 못했습니다. 잠시 후 다시 시도해주세요."
          );
          return false;
        });
    },
    extractActiveIdentityChangeRequest(data) {
      if (!data || Array.isArray(data)) {
        return null;
      }

      return Object.keys(data).length ? data : null;
    },
    openContractChangeDialog() {
      return this.openContractorDialog("change");
    },
    loadContractInfo() {
      this.showVerificationLoadingIfNeeded();
      this.contractArea = 0;
      this.contractor = {};
      this.contractorInfoLoaded = false;
      this.activeIdentityChangeRequest = null;
      this.activeIdentityChangeRequestFetchFailed = false;

      return getContract(this.home.id)
        .then((contractResult) => {
          this.contractInfo = contractResult.data;
          console.log(
            "contractInfo",
            this.contractInfo.sellInfo.depositBalance[0]
          );

          var areaType = "";
          this.contractInfo.supplyArea.forEach((element) => {
            if (element.name == "전용면적") {
              areaType = element.area.toString().split(".")[0];
            }
          });
          areaType += this.contractInfo.assetDesignType;
          this.contractInfo.areaType = areaType;

          this.contractInfo.supplyArea.filter((item) => {
            if (item.name == "전용면적" || item.name == "주거공용") {
              this.contractArea += Number(item.area);
            }
          });
          this.contractArea = this.contractArea.toFixed(4);

          if (this.contractInfo.assetCategory == "A") {
            this.contractInfo.assetCategory = "아파트";
          } else if (this.contractInfo.assetCategory == "S") {
            this.contractInfo.assetCategory = "상가";
          } else if (this.contractInfo.assetCategory == "F") {
            this.contractInfo.assetCategory = "공장";
          } else if (this.contractInfo.assetCategory == "W") {
            this.contractInfo.assetCategory = "업무시설";
          }

          return getContractorDetails(this.home.id)
            .then((contractorResult) => {
              this.contractor = contractorResult.data || {};
              if(this.contractor && !this.contractor.is_corporate) {
                return this.fetchActiveIdentityChangeRequest();
              }
            })
            .then(() => {
              this.contractorInfoLoaded = true;
              this.enforceContractorDialogAvailabilityFromRoute();
              this.handleVerificationResult();
            })
            .catch((e) => {
              console.log('error while fetching contractor for change', e);
              this.contractor = {};
              this.contractorInfoLoaded = true;
              this.enforceContractorDialogAvailabilityFromRoute();
              this.handleVerificationResult();
            });
        })
        .catch((e) => {
          console.log(e);
          this.finishVerificationLoading();
        });
    },
    openContractChangeWithVerification() {
      if (!this.hasContractorInfo) {
        this.$store.commit(
          "ERROR",
          "계약자 상세 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요."
        );
        return Promise.resolve();
      }

      return this.openContractorDialog("verification");
    },
    startContractorInfoVerification() {
      return this.clearContractorDialogRoute().then(() => {
        this.$store.commit("SET_VERIFICATON", {
          title: "실명인증",
          verified_name_type: false,
          dialog: true,
          redirect: this.$route.path,
          is_test: false,
          only_verified_name: true,
          is_contractor_info_update: true,
        });
      });
    },
    
    openHistoryDialog() {
      if (!this.hasContractorInfo) {
        this.$store.commit(
          "ERROR",
          "정보 변경 이력을 불러오지 못했습니다."
        );
        return Promise.resolve();
      }

      if (!this.showContractorActionButtons) {
        return;
      }

      this.openContractorDialog("history");
    },
    isContractorInfoUpdate(value) {
      return String(value || "") === "true";
    },
    isVerificationSuccess() {
      return this.$route.query.is_verified === "Y";
    },
    isVerificationFailed() {
      return this.$route.query.is_verified === "N";
    },
    // 인증 완료 후 복귀하면서 붙는 query만 제거한다.
    getQueryWithoutVerificationParams() {
      const query = { ...this.$route.query };
      delete query.is_verified;
      delete query.is_contractor_info_update;
      delete query[CONTRACTOR_DIALOG_QUERY_KEY];
      return query;
    },
    showVerificationLoadingIfNeeded() {
      if (
        this.isContractorInfoUpdate(this.$route.query.is_contractor_info_update) &&
        this.isVerificationSuccess() &&
        !this.isVerificationLoading
      ) {
        this.startVerificationLoading();
      }
    },
    // 인증 성공 후 사용자 정보 재조회가 끝날 때까지 진행 상태를 노출한다.
    startVerificationLoading() {
      this.isVerificationLoading = true;
      this.verificationBackNoticeLocked = false;
      this.enableVerificationBackGuard();
    },
    // 전환 상태와 뒤로가기 방어를 함께 정리한다.
    finishVerificationLoading() {
      this.isVerificationLoading = false;
      this.verificationBackNoticeLocked = false;
      this.disableVerificationBackGuard();
    },
    // 인증 복귀 직후 짧은 구간에서만 브라우저 뒤로가기를 방어한다.
    enableVerificationBackGuard() {
      if (this.verificationBackGuardActive) {
        return;
      }

      window.history.pushState(
        { contractorVerificationTransition: true },
        "",
        this.$route.fullPath
      );
      window.addEventListener("popstate", this.handleVerificationBackNavigation);
      this.verificationBackGuardActive = true;
    },
    disableVerificationBackGuard() {
      if (!this.verificationBackGuardActive) {
        return;
      }

      window.removeEventListener("popstate", this.handleVerificationBackNavigation);
      this.verificationBackGuardActive = false;
    },
    // 처리 중 뒤로가기가 들어오면 현재 화면을 유지하고 안내 문구만 보여준다.
    handleVerificationBackNavigation() {
      if (!this.isVerificationLoading) {
        return;
      }

      window.history.pushState(
        { contractorVerificationTransition: true },
        "",
        this.$route.fullPath
      );

      if (!this.verificationBackNoticeLocked) {
        this.verificationBackNoticeLocked = true;
        this.$store.commit(
          "INFO",
          "인증 결과를 확인하는 중입니다. 잠시만 기다려주세요."
        );
        setTimeout(() => {
          this.verificationBackNoticeLocked = false;
        }, 1500);
      }
    },
    // 인증 결과 query를 읽어 계약자 정보 변경 팝업 진입 전환을 제어한다.
    handleVerificationResult() {
      if (!this.isContractorInfoUpdate(this.$route.query.is_contractor_info_update)) {
        return;
      }

      if (!this.contractorInfoLoaded) {
        return;
      }

      const sanitizedQuery = this.getQueryWithoutVerificationParams();

      if (!this.showContractorActionButtons) {
        this.$router.replace({ query: sanitizedQuery });
        this.finishVerificationLoading();
        console.log("not allowed to change contractor info");
        return;
      }

      if (this.isVerificationSuccess()) {
        // query는 먼저 정리하고, 이후 사용자 정보를 최신 상태로 갱신한다.
        this.startVerificationLoading();
        this.$router.replace({ query: sanitizedQuery });
        getUserData("force_update=true")
          .then((res) => {
            this.$store.commit("SET_USER", res.data);
            return this.fetchActiveIdentityChangeRequest().then(() => this.openContractChangeDialog());
          })
          .catch((err) => {
            this.$store.dispatch("LOGGING", {
              error: err,
              tags: "StatusForSell|contractAPI|getUserData|verification",
              etc: {
                user: this.user.id,
                home_id: this.home.id,
              },
            });
            this.$store.commit(
              "ERROR",
              "본인인증 결과를 확인하지 못했습니다. 다시 시도해주세요."
            );
          })
          .finally(() => {
            this.finishVerificationLoading();
          });
      } else if (this.isVerificationFailed()) {
        this.$router.replace({ query: sanitizedQuery });
        this.$store.commit("ERROR", "본인인증에 실패하였습니다. 다시 시도해주세요.");
      } else {
        return;
      }
    },
    getTotalBalance(paymentList) {
      // TODO Object 넘어오는 현상 해결
      if (!paymentList) return 0;
      else if (!Array.isArray(paymentList)) return 0;

      return paymentList.reduce((acc, cur, i) => {
        return acc + cur.balance;
      }, 0);
    },
    // Utils
    getMoveinText() {
      let start = this.contractInfo.sellInfo.moveInDateStart;
      let end = this.contractInfo.sellInfo.moveInDateEnd;
      let date = this.contractInfo.moveInDate;

      if (start != end) {
        // 입주 예정일의 경우 수시로 바뀌게됨, 계약자에게 대략적인 정보만 공유
        // return start + " ~ " + end;
        return start.substr(0, 4) + "년 " + start.substr(5, 2) + "월 예정";
      } else {
        return date.substr(0, 4) + "년 " + date.substr(5, 2) + "월 예정";
      }
    },
    openBasicInfoDialog() {
      return this.openContractorDialog("basic");
    },
    openIdentityInfoDialog() {
      return this.openContractorDialog("identity");
    },
    handleIdentityInfoBack() {
      this.backToContractChangeDialog();
    },
    handleBasicInfoBack() {
      this.backToContractChangeDialog();
    },
    handleBasicInfoSubmit(payload) {
      if (this.basicInfoSubmitting) {
        return;
      }

      payload.role = this.contractor.role;

      this.basicInfoSubmitting = true;
      changeContractorBasicInfo(this.home.id, payload)
        .then(() => {
          this.resetContractorDialogs();
          return this.clearContractorDialogRoute();
        })
        .then(() => {
          return this.loadContractInfo();
        })
        .then(() => {
          this.$store.commit("INFO", "기본정보가 변경되었습니다.");
        })
        .catch((err) => {
          this.$store.dispatch("LOGGING", {
            error: err,
            tags: "StatusForSell|contractAPI|changeContractorBasicInfo",
            etc: {
              home_id: this.home.id,
              payload,
            },
          });
          this.$store.commit(
            "ERROR",
            err?.response?.data?.msg || "기본정보 변경에 실패했습니다. 잠시 후 다시 시도해주세요."
          );
        })
        .finally(() => {
          this.basicInfoSubmitting = false;
        });
    },
    handleBasicInfoSendEmailCode(email) {
      changeContractorBasicInfoSendEmailCode(this.home.id, email)
        .then(() => {
          this.$store.commit("INFO", "인증코드가 발송되었습니다.");
        })
        .catch((err) => {
          this.$store.commit("ERROR", "인증코드 발송에 실패했습니다. 잠시 후 다시 시도해주세요.");
        });
    },
    handleIdentityInfoSubmit(payload) {
      if (this.identityInfoSubmitting) {
        return;
      }

      const requestMode = payload._requestMode;
      delete payload._requestMode;
      payload.role = this.contractor.role;

      this.identityInfoSubmitting = true;
      changeContractorIdentityInfo(this.home.id, payload)
        .then(() => {
          this.resetContractorDialogs();
          return this.clearContractorDialogRoute();
        })
        .then(() => {
          return this.loadContractInfo();
        })
        .then(() => {
          this.$store.commit(
            "INFO",
            requestMode === "update"
              ? "계약자 개인정보 변경 요청이 수정되었습니다."
              : "계약자 개인정보 변경 요청이 접수되었습니다."
          );
        })
        .catch((err) => {
          // this.$store.dispatch("LOGGING", {
          //   error: err,
          //   tags: "StatusForSell|contractAPI|changeContractorIdentityInfo",
          //   etc: {
          //     home_id: this.home.id,
          //     payload,
          //   },
          // });
          console.log('changeContractorIdentityInfo error', err);
          this.$store.commit("ERROR", "계약자 개인정보 변경 요청에 실패했습니다. 잠시 후 다시 시도해주세요.");
        })
        .finally(() => {
          this.identityInfoSubmitting = false;
        });
    },
    hasIdentityChangedField(item) {
      return this.getChangedFields(item).some((field) =>
        ["name", "citizen_number"].includes(field.field)
      );
    },
    getChangedFields(item) {
      return Array.isArray(item?.changed_fields) ? item.changed_fields : [];
    },
    isApprovalLockedIdentityChangeStatus(status) {
      return this.normalizeIdentityChangeStatus(status) === "진행중";
    },
    isEditableIdentityChangeStatus(status) {
      return !["진행중", "완료"].includes(
        this.normalizeIdentityChangeStatus(status)
      );
    },
    normalizeIdentityChangeStatus(status) {
      return String(status || "").replace(/\s/g, "");
    },
  },
  created() {
    this.loadContractInfo();
  },
  beforeDestroy() {
    // 화면 이탈 시 남아 있을 수 있는 타이머와 뒤로가기 방어를 정리한다.
    this.finishVerificationLoading();
  },
};
</script>

<style scoped>
.contract-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.contract-action-section {
  margin: 18px 0 24px;
}

.contract-action-button {
  min-width: 126px;
  height: 38px;
  padding: 0 14px;
  border: 1px solid #232323;
  background-color: #e66a1f;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

.contract-action-button.is-primary {
  background-color: #e66a1f;
}

.contract-action-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.contract-change-popup {
  border-radius: 20px;
  background-color: #ffffff;
  padding: 28px 24px 22px;
}

.contract-change-popup__title {
  display: block;
  margin-bottom: 28px;
  text-align: center;
  color: #e66a1f;
  font-size: 24px;
  font-weight: 700;
}

.contract-change-popup__actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.popup-action-button {
  width: 184px;
  min-height: 62px;
  border: 0;
  border-radius: 999px;
  padding: 0 14px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
}

.popup-action-button span {
  display: block;
}

.popup-action-button.is-orange {
  background-color: #e66a1f;
}

.popup-action-button.is-dark {
  background-color: #00181a;
}

.popup-action-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.contract-change-popup__helper {
  margin: 0 0 18px;
  text-align: center;
  color: #767676;
  font-size: 13px;
  line-height: 1.5;
  word-break: keep-all;
}

.contract-change-popup__notes {
  margin-bottom: 22px;
}

.contract-change-popup__notes p {
  margin: 0 0 8px;
  color: #e66a1f;
  font-size: 13px;
  line-height: 1.5;
  word-break: keep-all;
}

.contract-change-popup__notes p:last-child {
  margin-bottom: 0;
}

.contract-change-popup__footer {
  display: flex;
  justify-content: flex-end;
}

.contract-change-popup__close {
  min-width: 78px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background-color: #d9d9d9;
  color: #222222;
  font-size: 14px;
  font-weight: 700;
}

.contract-complete-popup {
  border-radius: 18px;
  background-color: #ffffff;
  padding: 24px 20px 18px;
}

.contract-complete-popup__title {
  display: block;
  margin-bottom: 12px;
  text-align: center;
  color: #232323;
  font-size: 20px;
  font-weight: 700;
}

.contract-complete-popup__text {
  margin: 0 0 20px;
  text-align: center;
  color: #232323;
  font-size: 15px;
  line-height: 1.5;
}

.contract-complete-popup__footer {
  display: flex;
  justify-content: center;
}

.contract-complete-popup__button {
  min-width: 96px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background-color: #e66a1f;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}

.verification-transition-popup {
  border-radius: 18px;
  background-color: #ffffff;
  padding: 28px 22px 24px;
}

.verification-transition-popup__title {
  display: block;
  margin-bottom: 18px;
  text-align: center;
  color: #232323;
  font-size: 20px;
  font-weight: 700;
}

.verification-transition-popup__progress {
  margin-bottom: 14px;
}

.verification-transition-popup__text {
  margin: 0;
  text-align: center;
  color: #232323;
  font-size: 15px;
  line-height: 1.6;
  word-break: keep-all;
}

.verification-transition-popup__notice {
  margin: 10px 0 0;
  text-align: center;
  color: #767676;
  font-size: 13px;
  line-height: 1.5;
  word-break: keep-all;
}

@media (max-width: 359px) {
  .contract-action-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .contract-action-button {
    width: 100%;
    min-width: 0;
  }

  .contract-change-popup {
    padding: 24px 18px 18px;
  }

  .contract-change-popup__actions {
    flex-direction: column;
    align-items: stretch;
  }

  .popup-action-button {
    width: 100%;
  }
}
</style>
